import { Stack } from 'src/core/ui';

import AnimatingNumber, { AnimatingNumberProps } from './AnimatedNumber';
import * as styles from './DataInsightsChart.css';

export type ChartHeaderInput = {
  subtitle?: string;
  chartHeaderPostfix?: string;
} & AnimatingNumberProps;

export const ChartHeader = ({
  subtitle,
  value = 0,
  prefix,
  chartHeaderPostfix,
  decimals,
  isScrolling,
}: ChartHeaderInput) => {
  if (!value) {
    return null;
  }
  return (
    <Stack direction={'column'} style={{ minWidth: 0 }}>
      <Stack>
        <AnimatingNumber
          value={value}
          isScrolling={isScrolling}
          prefix={prefix}
          decimals={decimals}
        />
        {chartHeaderPostfix && (
          <span className={styles.chartHeaderPostfix}>
            {chartHeaderPostfix}
          </span>
        )}
      </Stack>
      {subtitle && (
        <span className={styles.chartHeaderSubtitle}>{subtitle}</span>
      )}
    </Stack>
  );
};
